import React from 'react';
import PropTypes from 'prop-types';

import { OverlayTrigger, Tooltip } from 'react-bootstrap-5';

import InitialsBubble from 'components/initials_bubble';

const LabeledProfilePhoto = ({ initials, photoUrl, value }) => {
  const tooltip = <Tooltip id='profile-photo-tooltip'>{value}</Tooltip>;

  return (
    <OverlayTrigger overlay={tooltip} placement="bottom">
      {photoUrl ? (
        <span className="avatar avatar-lg">
          <img className="avatar-image w-100 h-100 object-fit-cover" src={photoUrl} title={value} />
        </span>
      ) : (
        <span>
          <InitialsBubble preview={false} text={initials} />
        </span>
      )}
    </OverlayTrigger>
  );
};

LabeledProfilePhoto.propTypes = {
  initials: PropTypes.string,
  photoUrl: PropTypes.string,
  value: PropTypes.string.isRequired
};

export default LabeledProfilePhoto;
